import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class FormationService {
  private skills = new Subject<void>();
  private formations = new Subject<void>();

  SkillsObservable$ = this.skills.asObservable();
  FormationsObservable$ = this.formations.asObservable();

    notifyAllSkills() {
      this.skills.next();
    }

    notifyAllFormations() {
      this.formations.next();
    }
  }
